import { render, staticRenderFns } from "./ElementTable.vue?vue&type=template&id=aa2a6556&"
import script from "./ElementTable.vue?vue&type=script&lang=js&"
export * from "./ElementTable.vue?vue&type=script&lang=js&"
import style0 from "./ElementTable.vue?vue&type=style&index=0&id=aa2a6556&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports